class ExpectedDelivery extends HTMLElement {
  connectedCallback() {
    const raw = this.getAttribute('data-days') || '';
    const match = raw.trim().toLowerCase().match(/(\d+)/);
 
    if (!match) {
      this.textContent = 'Expected delivery unavailable';
      return;
    }
 
    const daysToAdd = parseInt(match[1], 10);
    const today = new Date();
    const endDate = new Date(today);
    endDate.setDate(today.getDate() + daysToAdd);
 
    const startDay = this.getDayWithSuffix(today.getDate());
    const endDay = this.getDayWithSuffix(endDate.getDate());
 
    const startMonth = today.toLocaleString('default', { month: 'long' });
    const endMonth = endDate.toLocaleString('default', { month: 'long' });
 
    let output = '';
 
    if (startMonth === endMonth) {
      output = `Expected delivery between ${startDay}–${endDay} of ${endMonth}`;
    } else {
      output = `Expected delivery between ${startDay} ${startMonth} – ${endDay} ${endMonth}`;
    }
 
    this.textContent = output;
  }
 
  getDayWithSuffix(day) {
    if (day >= 11 && day <= 13) return `${day}th`;
    switch (day % 10) {
      case 1: return `${day}st`;
      case 2: return `${day}nd`;
      case 3: return `${day}rd`;
      default: return `${day}th`;
    }
  }
}
 
customElements.define('expected-delivery', ExpectedDelivery);

 